import FormatService from '../../../services/format-service';
import FormService from '../../../services/form-service';

const SettingsDealTemplateListValidator: Validator = (values: FormValues): ValidationErrors => {
  const errors: ValidationErrors = {};

  const formKeyNew: string = FormService.getIndexedFormFieldKey(FormService.FORM_KEY_NEW);

  const requiredFields: string[] = [
    'title',
    'type',
  ];

  const jsonFields: string[] = [
    'initialData',
    'hiddenFields',
    'customSections',
    'customListTypes',
  ];

  if (values.dealTemplateListData) {
    if (!errors.dealTemplateListData) {
      errors.dealTemplateListData = {};
    }

    Object.keys(values.dealTemplateListData).forEach((dealTemplateIndex: string): void => {
      const dealTemplateData: ValidationEntityInput = {
        ...values.dealTemplateListData[dealTemplateIndex],
      };

      if (dealTemplateData) {
        if (!errors.dealTemplateListData[dealTemplateIndex]) {
          errors.dealTemplateListData[dealTemplateIndex] = {};
        }

        requiredFields.forEach((field: string): void => {
          if ((!dealTemplateData[field] || !dealTemplateData[field].toString().trim())
            && dealTemplateData[field] !== null) {
            errors.dealTemplateListData[dealTemplateIndex][field] = 'Required';
          }
        });

        jsonFields.forEach((field: string): void => {
          if (dealTemplateData[field] && !FormatService.isValidJson(dealTemplateData[field])) {
            errors.dealTemplateListData[dealTemplateIndex][field] = 'Invalid JSON format';
          }
        });

        if (errors.dealTemplateListData[dealTemplateIndex] && (
          !Object.keys(errors.dealTemplateListData[dealTemplateIndex]).length
          || (dealTemplateIndex === formKeyNew && dealTemplateData.name === null)
        )) {
          delete errors.dealTemplateListData[dealTemplateIndex];
        }
      }
    });

    if (errors.dealTemplateListData && !Object.keys(errors.dealTemplateListData).length) {
      delete errors.dealTemplateListData;
    }
  }

  return errors;
};

export default SettingsDealTemplateListValidator;
